import React, { useCallback, useEffect } from "react";

import NewSchoolCategories from "../../components/School/NewSchoolCategories";
import NewSchoolCell from "../../components/School/SchoolCell/NewSchoolCell";
import Props from "./props";
import SaveNewSchool from "../../components/School/SaveNewSchool";
import StyledTablePaper from "../../components/ui/TablePaper/styled";
import TablePaper from "../../components/ui/TablePaper";
import resetNewSchoolFieldsAction from "../../../state/actions/SchoolActions/resetNewSchoolFieldsAction";
import sendNewSchoolAction from "../../../state/actions/SchoolActions/sendNewSchoolAction";
import styled from "styled-components";
import { useAppTitle } from "../../../state/hooks/MainHooks/useAppTitle";
import { useDispatch } from "react-redux";
import useSchoolsAndCategories from "../../../state/hooks/SchoolHooks/useSchoolsAndCategories";

interface Field {
    field: string;
    label: string;
}

const New: React.FC<Props> = (props) => {
    useSchoolsAndCategories();
    const dispatch = useDispatch();
    const { setAppTitle } = useAppTitle();
    const resetNewSchoolFields = useCallback(() => dispatch(resetNewSchoolFieldsAction()), [dispatch]);
    const sendNewSchool = useCallback(() => dispatch(sendNewSchoolAction()), [dispatch]);
    useEffect(() => {
        setAppTitle(props.title);
        return () => {
            setAppTitle("");
        };
    }, [setAppTitle, props.title]);
    useEffect(() => {
        return () => {
            resetNewSchoolFields();
        };
    }, [resetNewSchoolFields]);
    const fields: Field[] = [
        {
            field: "post_title",
            label: "Nome",
        },
        {
            field: "what_to_study",
            label: "Cosa di studia",
        },
        {
            field: "what_subject_matter",
            label: "Quali materia",
        },
        {
            field: "what_study_addresses",
            label: "Quali indirizzi",
        },
        {
            field: "what_study_job_prospects",
            label: "Quali prospettive di studio o lavoro?",
        },
        {
            field: "what_nearby",
            label: "Sul territorio",
        },
    ];
    return (
        <Wrapper
            onSubmit={(e: React.FormEvent) => {
                e.preventDefault();
                sendNewSchool();
            }}
        >
            <SaveNewSchool />
            <TablePaper>
                {fields.map(({ field, label }) => (
                    <NewSchoolCell key={field} field={field} label={label} />
                ))}
                <NewSchoolCategories />
            </TablePaper>
        </Wrapper>
    );
};

export default New;

const Wrapper = styled.form`
    width: 60rem;
    margin: 0 auto;
    padding: 5rem 0;
    ${StyledTablePaper} {
        padding-top: 5rem;
    }
`;
